<template>
  <v-col class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-account-multiple"
    ></vuse-section-definition>
    <v-container class=" p-5" fluid>
      <v-row class="mr-4">
        <v-col class="white rounded-lg" cols="8">
          <v-col cols="12">
            <v-text-field
                v-model="partner.name"
                filled
                label="Tên"
                placeholder="Nhập tên"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
                v-model="partner.order"
                filled
                label="Vị trí"
                placeholder="Nhập vị trí"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-file-input
                v-model="image"
                label="Ảnh "
                placeholder="Tải ảnh lên"
                prepend-icon="mdi-camera"
                @change="uploadImg"
            ></v-file-input>
            <div v-if="display_image">
              <v-img
                  :src="display_image"
                  aspect-ratio="1.7"
                  contain
                  width="200"
              ></v-img>
            </div>
          </v-col>
          <v-col align="center" cols="12">
            <v-btn
                color="primary"
                width="180"
                @click="save()"
            >
              Lưu
            </v-btn>
          </v-col>
        </v-col>
      </v-row>
    </v-container>
  </v-col>
</template>

<script>
import {UPLOAD_IMAGE} from "@/store/modules/field_project";
import {SAVE_PARTNER} from "@/store/modules/partner";

export default {
  name: "Add_partner",
  data() {
    return {
      page: "Danh sách Partner",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Danh sách Partner",
          disabled: true,
        },
        {
          text: "Thêm Partner",
          disabled: false,
        },
      ],
      image: null,
      display_image: '',
      partner: {
        name: '',
        photo_url: '',
        order: ''
      },
    }
  },
  methods: {
    uploadImg(e) {
      if (e) {
        this.display_image = URL.createObjectURL(e)
      }
      this.$forceUpdate()
    },
    async save() {
      let formDateAvatar = new FormData();
      formDateAvatar.append("upload", this.image);
      formDateAvatar.append("type", "ckeditor");
      formDateAvatar.append("position_type", "1");
      await this.$store.dispatch(`${UPLOAD_IMAGE}`, formDateAvatar).then((data) => {
            if (data.data.status == 1) {
              this.partner.photo_url = data.data.data[0].path
            }
          }
      )
      let data = {
        name: this.partner.name,
        photo_url: this.partner.photo_url,
        order: this.partner.order
      }

      await this.$store.dispatch(`${SAVE_PARTNER}`, data).then((data) => {
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration: 1000,
            position: 'top-center'
          })
          this.$router.push('/partner')
        }
      });
    }
  }
}
</script>

<style scoped>

</style>